import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=04f5d991&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=04f5d991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f5d991",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f5d991')) {
      api.createRecord('04f5d991', component.options)
    } else {
      api.reload('04f5d991', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=04f5d991&scoped=true&", function () {
      api.rerender('04f5d991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8w1RpJwLpr5Np/JS/comp/DateRangeExt.vue"
export default component.exports